import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/offer';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById('hero-cta');
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-141" data-mp="2av1sk4yk3j1q">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-3" data-id="element-142" data-mp="38ap4io1tzu9c">
          <div className="mx-auto max-w-md" data-id="element-143" data-mp="333sx4av1nn01">
            <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2.5 rounded-2xl bg-cta px-5 py-4 text-[16px] font-extrabold uppercase tracking-wide text-white shadow-[0_6px_0_#0E6B31,0_12px_30px_rgba(11,27,51,0.35)] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-lg" data-id="element-144" data-mp="335ndrcza8syb">
              <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-145" data-mp="2kemgctdt95gv" />
              <span className="whitespace-nowrap" data-id="element-146" data-mp="26elilmsuee5m">Get It Now — Only $27</span>
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}